// Game entry point: builds the Phaser instance, wires scenes, and hooks up
// the page-level mute toggle.

import Phaser from 'phaser';
import { config } from './config';
import { brand } from './brand';
import { BootScene } from './scenes/BootScene';
import { IntroScene } from './scenes/IntroScene';
import { TutorialScene } from './scenes/TutorialScene';
import { GameScene } from './scenes/GameScene';
import { BossScene } from './scenes/BossScene';
import { EndScene } from './scenes/EndScene';

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: brand.bg,
  width: config.arena.width,
  height: config.arena.height,
  pixelArt: true,
  roundPixels: true,
  antialias: false,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [BootScene, IntroScene, TutorialScene, GameScene, BossScene, EndScene],
});

// Mute toggle (persists in localStorage)
const muteBtn = document.getElementById('mute-toggle');
const STORAGE = 'zdc:muted';
const applyMute = (muted: boolean) => {
  game.sound.mute = muted;
  if (muteBtn) {
    muteBtn.textContent = muted ? '\u{1F507}' : '\u{1F50A}';
    muteBtn.classList.toggle('muted', muted);
  }
};
applyMute(localStorage.getItem(STORAGE) === '1');
muteBtn?.addEventListener('click', () => {
  const next = !game.sound.mute;
  localStorage.setItem(STORAGE, next ? '1' : '0');
  applyMute(next);
});

// Pause when tab hidden — both the render loop AND audio. Without the
// audio pause, BGM keeps looping while the tab is in the background.
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    game.loop.sleep();
    game.sound.pauseAll();
  } else {
    game.loop.wake();
    if (!game.sound.mute) game.sound.resumeAll();
  }
});
